module.exports = __webpack_public_path__ + "images/d47748e70e467e82b336468ab8a1d201.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Shell/scenes/Header/img/logo.png
// module id = 1922
// module chunks = 0